// assets
import TeamOutlined from '@ant-design/icons/TeamOutlined';

// icons
const icons = { TeamOutlined };

// ==============================|| MENU ITEMS - USERS ||============================== //

const users = {
  id: 'group-users',
  title: 'Organization',
  type: 'group',
  children: [
    {
      id: 'users',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    }
  ]
};

export default users;
